<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="1600">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-format-list-bulleted</v-icon> Lista de Presença
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-row class="justify-center mt-7">
            <v-col cols="8">
              <v-text-field
                :value="content.formacao"
                label="Formação"
                readonly
                outlined
                dense
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="content.cargaHoraria"
                label="Carga Horária"
                readonly
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row class="justify-center mt-7">
            <v-col cols="8">
              <v-text-field
                :value="$formatarData(content.dataRealizacao)"
                label="Data de Realização"
                readonly
                outlined
                dense
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="content.localRealizacao"
                label="Local de Realização"
                readonly
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row class="d-flex justify-center">
            <v-col cols="12">
              <span class="small">Instrutor(es)</span>
              <div class="instrutores-box">
                <v-chip-group active-class="primary--text" column>
                  <v-chip v-for="instrutor in content.listaInstrutores" :key="instrutor.id">
                    {{ instrutor.nome }}
                  </v-chip>
                </v-chip-group>
              </div>
            </v-col>
          </v-row>

          <v-data-table
            class="mt-5 tabela-presenca"
            :headers="table.headers"
            :items="table.itens"
            :items-per-page="10"
            :footer-props="$footerProps"
          >
            <template v-slot:item.presente="{ item }">
              <v-radio-group
                v-model="item.presente"
                :disabled="content.bloquearCampos"
                hide-details
                @change="(val) => {
                  if (val === 'Presente') item.ausente = null;}">
                <v-radio class="mb-3" :label="''" value="Presente" />
              </v-radio-group>
            </template>
            <template v-slot:[`item.cpf`]="{ item }">
              {{ $esconderCpf(item.cpf) }}
            </template>
            <template v-slot:item.ausente="{ item }">
              <v-radio-group
                v-model="item.ausente"
                :disabled="content.bloquearCampos"
                hide-details
                @change="(val) => {if (val === 'Ausente') item.presente = null;}">
                <v-radio class="mb-3" :label="''" value="Ausente" />
              </v-radio-group>
            </template>
            <template v-slot:top>
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-btn v-if="!content.bloquearCampos" icon @click="abrirModalAdicionarParticipante">
                  <v-icon color="primary">mdi-account-plus</v-icon>
                </v-btn>
              </v-toolbar>
            </template>
          </v-data-table>

          <v-row v-if="!content.bloquearCampos" class="mt-5">
            <v-col cols="12">
              <v-checkbox v-model="confirmacaoPresenca">
                <template v-slot:label>
                  <div>
                    Eu, <span class="blue--text">{{ $user.fullName }}</span>, CPF <span class="blue--text">{{ $formatCpf($user.username) }}</span>,
                    declaro, sob minha responsabilidade,
                    que a confirmação de presença nesta formação foi realizada de forma consciente e verdadeira,
                    estando plenamente ciente das implicações decorrentes desta declaração.
                  </div>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
          <div v-if="content.bloquearCampos" class="d-flex justify-center mb-4">
            <v-row class="d-flex justify-center" no-gutters>
              <v-col cols="auto">
                <sigfoco-buttons
                actionText="Baixar PDF"
                cancelText="Baixar CSV"
                @click="baixarRelatorioPdf"
                @cancel="baixarCSVRelatorio"
                ></sigfoco-buttons>
              </v-col>
              <v-col cols="auto" class="mt-4">
                <v-btn color="primary" outlined @click="$emit('onClose')">
                  Fechar
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <v-row v-else class="d-flex justify-center mb-4" >
            <v-btn color="primary" class="mr-3" :disabled="!confirmacaoPresenca" @click="salvar">Salvar</v-btn>
            <v-btn outlined color="primary" @click="$emit('onClose')">Cancelar</v-btn>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalAdicionar" max-width="800px">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Incluir Usuário</v-toolbar-title>
        </v-toolbar>

        <v-card-text class="mt-7">
          <v-text-field
            v-model="novoParticipante.cpf"
            label="CPF do Usuário"
            outlined
            dense
            maxlength="14"
            :disabled="desabilitaCamposUsuario"
            v-mask="'###.###.###-##'"
          />
          <v-text-field
            v-if="novoParticipante.nome"
            v-model="novoParticipante.nome"
            label="Nome do Usuário"
            readonly
            outlined
            dense
            class="mt-4"
          />
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn color="primary" v-if="!desabilitaCamposUsuario" @click="aoBuscarCpf">Buscar</v-btn>
          <v-btn color="primary" v-if="!!novoParticipante.nome" @click="confirmarAdicionarParticipante">Salvar</v-btn>
          <v-btn outlined color="primary" @click="modalAdicionar = false; desabilitaCamposUsuario = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { ListaPresenca } from "~/commons/classes/lista-presenca";
import { AUTH_NAMESPACE, USER, LOGIN} from 'store/modules/auth';
import ListaPresencaService from "~/services/manter-lista-presenca.service"; 
export default {
  computed: {
  user() {
    return this.$store.getters[`${AUTH_NAMESPACE}/${USER}/${LOGIN}`];
  },
},
  mixins: [ListaPresencaService],
  props: new DialogProps(ListaPresenca),
  data() {
    return {
      confirmacaoPresenca: false,
      modalAdicionar: false,
      desabilitaCamposUsuario: false,
      novoParticipante: {
        cpf: '',
        nome: ''
      },
      table: {
        headers: [
          { text: "CPF", value: "cpf", align: "start" },
          { text: "Nome do Participante", value: "nome", align: "start" },
          { text: "Presente", value: "presente", align: "start", sortable: false },
          { text: "Ausente", value: "ausente", align: "start", sortable: false }
        ],
        itens: []
      }
    };
  },
  watch: {
    content: {
      handler() {
        this.carregarParticipantes();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    salvar() {
      const save = () => {
        return this.$swal({
          text: `Deseja confirmar esta operação? A lista de presença será enviada para validação pelo aprovador após o envio da ata.`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const payload = {
            formacaoId: this.content.id,
            participantes: this.table.itens.map((p) => {
              const participante = this.content.participantes.find(part => part.cpf === p.cpf);
              return {
                usuarioId: participante?.usuarioId || null,
                presenca: p.presente === 'Presente' ? true : p.ausente === 'Ausente' ? false : null,
              };
            }),
          };
          return this.$editar(payload, this.content.id);
        });
      };
      const participantesInvalidos = this.table.itens.filter((p) => p.presente === null && p.ausente === null);
      if (participantesInvalidos.length > 0) {
        this.$notifyWarning('Preencha os campos obrigatórios de presença/ausência para todos os participantes.');
        return;
      }

      save()
        .then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        })
    },
    carregarParticipantes() {
      if (this.content && this.content.participantes) {
        this.table.itens = this.content.participantes.map((participante) => {
          let presente = null;
          let ausente = null;

          if (participante.presente === true) presente = 'Presente';
          if (participante.ausente === true) ausente = 'Ausente';

          return {
            cpf: participante.cpf,
            nome: participante.nome,
            usuarioId: participante.usuarioId,
            presente,
            ausente,
          };
        });
      } else {
        this.table.itens = [];
      }
    },
    abrirModalAdicionarParticipante() {
      this.novoParticipante = { cpf: '', nome: '' };
      this.modalAdicionar = true;
    },
    aoBuscarCpf() {
      const cpfLimpo = this.novoParticipante.cpf.replace(/\D/g, '');
      if (cpfLimpo.length !== 11) return;
      this.buscarUsuarioPorCpf(cpfLimpo);
    },
    buscarUsuarioPorCpf(cpf) {
      const cpfFormatado = cpf.replace(/\D/g, '');

      if (cpfFormatado.length !== 11) {
        this.novoParticipante.nome = '';
        return;
      }
      this.$obter(cpfFormatado)
        .then((response) => {
          const data = response.data.item;
          this.novoParticipante.usuarioId = data.usuarioId;
          this.novoParticipante.nome = data.nome;
          this.desabilitaCamposUsuario = true;
        })
        .catch(() => {
          this.novoParticipante.nome = '';
          this.desabilitaCamposUsuario = false;
          this.$notifyError('Usuário não encontrado com o CPF informado.');
        });
    },

    confirmarAdicionarParticipante() {
      const { cpf, nome, usuarioId } = this.novoParticipante;

      const jaExiste = this.table.itens.some(p => p.cpf?.replace(/\D/g, '') === cpf?.replace(/\D/g, ''));
      if (jaExiste) {
        this.$notifyWarning('Este CPF já está na lista de participantes.');
        return;
      }

      const novo = {
        cpf,
        nome,
        usuarioId,
        presente: null,
        ausente: null
      };

      this.content.participantes.push(novo);
      this.table.itens.push(novo);

      this.novoParticipante = { cpf: '', nome: '', usuarioId: null };
      this.desabilitaCamposUsuario = false;
      this.modalAdicionar = false;
    },
    async baixarRelatorioPdf() {
      this.showPageLoading();
      try {
        const { data } = await this.$obterListaPresencaPDF(this.$montarParamsFilters({FormacaoId: this.content?.id}));
        const url = URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "SIGFOCO.ListadePresença .pdf");
        document.body.appendChild(link);
        link.click();
        this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
        this.hidePageLoading();
      }
    },
    async baixarCSVRelatorio() {
      this.showPageLoading();
      try {
      const { data } = await this.$obterListaPresencaCSV(this.content.id);
      this.$baixarRelatorioCSV(data, `SIGFOCO.ListadePresençaCSV`);
      this.$notifySuccess("Operação realizada com sucesso.");
      } finally {
      this.hidePageLoading();
      }
    },
  }
}
  
</script>

<style scoped>
.instrutores-box {
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  margin-top: 10px;
}
.v-data-table-header th {
  vertical-align: middle !important;
}
</style>
